
import React,{useEffect} from 'react'
import { InputGroup, Button } from '../../UI'
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
import axios from 'axios';
import jsonp from 'jsonp'
import { useSelector} from 'react-redux'
import {Link} from 'react-router-dom'

const SignInForm = ({ handleInput, formData, loading , address, setDistance, setDistance2, setAddress, address2, setAddress2}) => {


  const { userData } = useSelector((s) => s.UserData)
  const handleSelect = async value => {
   const result = await geocodeByAddress(value)
   const location =await getLatLng(result[0])
   setDistance(location)
 setAddress(value);
  };
  const handleSelect2 = async value => {
    const result = await geocodeByAddress(value)
   const location = await getLatLng(result[0])
    setDistance2(location)
    setAddress2(value);
  };


  return (
    <>
      <InputGroup
        label="Email address"
        name="email"
        type="email"
        required={true}
        placeholder={'Enter your email address'}
        value={userData.length >1?formData.email: userData.email}
        onChange={handleInput}
      />
      <h3 className="primary--text">PICK UP DETAILS</h3>
      <PlacesAutocomplete
        value={address}
        name="pick_up_address"
        title="Pick up address"
        onChange={setAddress}
        onSelect={handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <InputGroup 
            label="Pick up address"
            name="address"
            required={true}
            onFocus={handleInput}
            type="text"
            placeholder={'Enter your address '}
            {...getInputProps({ placeholder: "Type address" })} />
            <div style={{marginTop:-20}}>
              {loading ? <div>...loading</div> : null}
              {suggestions.filter((values)=>{
                if(values.terms[values.terms.length - 1].value.includes("Nigeria")){
                  return values
                }
              }).map(suggestion => {
                const style = {
                  backgroundColor: suggestion.active ? "#41b6e6" : "#313446", padding:10
                };
                return (
                  <div {...getSuggestionItemProps(suggestion, { style })}>
                    {suggestion.description}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    <div style={{ height:20}}/>
      <InputGroup
        label="Pick up full name"
        name="pick_up_full_name"
        required={true}
        type="text"
        placeholder={'Enter your full name  '}
        value={formData.pick_up_full_name}
        onChange={handleInput}
      />
      <InputGroup
        label="Pick up phone number"
        name="pick_up_phone_number"
        required={true}
        type="tel"
         placeholder={'+237xxxxxxxx'}
        value={formData.pick_up_phone_number}
        onChange={handleInput}
      />
   
      <h3 className="primary--text">RECIPENT DETAILS</h3>
      
      <PlacesAutocomplete
        value={address2}
        name="Delivery_address"
        title="Dellivery address"
        onChange={setAddress2}
        onSelect={handleSelect2}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <InputGroup 
            label="Delivery address"
            name="Delivery address"
            required={true}
            onFocus={handleInput}
            type="text"
            placeholder={'Enter your address '}
            {...getInputProps({ placeholder: "Type address" })} />
            <div style={{marginTop:-20}}>
              {loading ? <div>...loading</div> : null}
              {suggestions.filter((values)=>{
                if(values.terms[values.terms.length - 1].value.includes("Nigeria")){
                  return values
                }
              }).map(suggestion => {
                const style = {
                  backgroundColor: suggestion.active ? "#41b6e6" : "#313446", padding:10
                };
                return (
                  <div {...getSuggestionItemProps(suggestion, { style })}>
                    {!loading && suggestion.description}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
      <div style={{ height:20}}/>
     <InputGroup
        label="Recipient full name"
        name="recipient_full_name"
        required={true}
        type="text"
        placeholder={'Enter the recipent full name '}
        value={formData.recipient_full_name}
        onChange={handleInput}
      />
      <InputGroup
        label="Recipient Phone number"
        name="recipient_phone_number"
        required={true}
        type="tel"
        placeholder={'+237xxxxxxxx'}
        value={formData.recipient_phone_number}
        onChange={handleInput}
      />
      <Button
        full
        className="auth--btn"
        loading={loading}
        spinnerWithTxt={true}
        type="submit"
      >
        Next
      </Button>
      
    </>
  )
}

export default SignInForm
